import { render } from "./HoursTableNavigation.vue?vue&type=template&id=bf1989e6"
import script from "./HoursTableNavigation.vue?vue&type=script&lang=js"
export * from "./HoursTableNavigation.vue?vue&type=script&lang=js"

import "./HoursTableNavigation.vue?vue&type=style&index=0&id=bf1989e6&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__